<rt-dialog-header [heading]="candidate.name"> </rt-dialog-header>
<rt-dialog-body layout-vertical>
  <rt-box layout-vertical>
    @if (!loading) {
      <img class="candidate-photo" src="{{ photoUrl }}" />
    }
    @if (loading) {
      <rt-spinner></rt-spinner>
    }
  </rt-box>
</rt-dialog-body>
